import code from './code'

export default {
    code
}
